import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import classnames from 'classnames'

// Components
import { Text, Button } from '../../../..'
import { Player } from '../../../../shared/Player'

// Selectors
import { selectBuyerWelcomeVideoId, selectBuyerWelcomeVideoType } from '../../../../../store/selectors/videos'
import { selectCustomerFirstName } from '../../../../../store/selectors/customerProfile'

// Styles
import styles from './BuyerWelcomeVideo.module.scss'
import baseStyles from '../../BuyerOnboardingWizard.module.scss'

const BuyerWelcomeVideo = ({ handleSubmitClick }) => {
  const videoId = useSelector(selectBuyerWelcomeVideoId)
  const videoType = useSelector(selectBuyerWelcomeVideoType)
  const customerFirstName = useSelector(selectCustomerFirstName)

  return (
    <div className={classnames(baseStyles.step, styles.step)}>
      <Text size='xl' variant='neutralCool' variantCount='900' className={styles.header}>
        <FormattedMessage id='BuyerWelcomeVideo.title' defaultMessage='Welcome to Homebot for buyers' />
      </Text>
      <Text variant='neutralCool' variantCount='700' className={styles.subHeader}>
        <FormattedMessage
          id='BuyerWelcomeVideo.subTitle'
          defaultMessage='Here’s a quick video from {customerFirstName} on how to get started:'
          values={{
            customerFirstName
          }}
        />
      </Text>
      <div className={styles.videoContainer}>
        <Player videoType={videoType} videoId={videoId} />
      </div>
      <Button onClick={handleSubmitClick} className={styles.button}>
        <FormattedMessage id='BuyerWelcomeVideo.button' defaultMessage='Get started' />
      </Button>
    </div>
  )
}

BuyerWelcomeVideo.propTypes = {
  handleSubmitClick: PropTypes.func
}

export default BuyerWelcomeVideo
